










































import Vue from 'vue'
import { SpeciesDto } from '@/Application/Batch/Species/SpeciesDto'
import SpeciesTargetRow from '@/UI/AuctionB/Declarations/OfferTable/SpeciesTargetRow.vue'
import { ResultasOffer } from '@/Infrastructure/Store/AuctionB/ResultasOffer'
import { Currency } from '@/Domain/Batch/Currency'

interface TargetPriceData {
  label: string;
  price: string;
  totalPrice: string;
  isValid: boolean;
}

export default Vue.extend({
  name: 'SpeciesOfferTableRow',
  components: { SpeciesTargetRow },
  props: {
    species: {
      type: Object as () => SpeciesDto,
      required: true
    },
    recordId: {
      type: String,
      required: true
    },
    previousOffer: {
      type: Object as () => ResultasOffer
    }
  },
  data () {
    return {
      sawOneUnitPrice: '',
      sawOneTotalPrice: '',
      sawTwoUnitPrice: '',
      sawTwoTotalPrice: '',
      grindedUnitPrice: '',
      grindedTotalPrice: ''
    }
  },
  watch: {
    previousOffer (newValue: ResultasOffer | null, oldValue: ResultasOffer | null) {
      if (newValue !== null && newValue !== oldValue) {
        this.parsePreviousOffer(newValue)
      } else { this.cleanValues() }
    },
    species (newValue: SpeciesDto, oldValue: SpeciesDto) {
      if (newValue.internalId !== oldValue.internalId) {
        this.parsePreviousOffer(this.previousOffer)
      } else { this.cleanValues() }
    }
  },
  created () {
    if (this.previousOffer !== null) {
      this.parsePreviousOffer(this.previousOffer)
    } else { this.cleanValues() }
  },
  computed: {
    identifier (): string {
      return this.recordId + this.species.internalId
    },
    hasSawOne (): boolean {
      return this.species.sawOneVolume !== '-'
    },
    hasSawTwo (): boolean {
      return this.species.sawTwoVolume !== '-'
    },
    hasGrinded (): boolean {
      return this.species.grindedVolume !== '-'
    },
    showRowTwo (): boolean {
      return !this.hasSawOne
    },
    showRowThree (): boolean {
      return !this.hasSawOne && !this.hasSawTwo
    }
  },
  methods: {
    cleanValues (): void {
      this.sawOneUnitPrice = ''
      this.sawOneTotalPrice = ''
      this.sawTwoUnitPrice = ''
      this.sawTwoTotalPrice = ''
      this.grindedUnitPrice = ''
      this.grindedTotalPrice = ''
    },
    parsePreviousOffer (offer: ResultasOffer): void {
      this.sawOneUnitPrice = offer && offer.sawOne ? offer.sawOne : ''
      this.sawTwoUnitPrice = offer && offer.sawTwo ? offer.sawTwo : ''
      this.grindedUnitPrice = offer && offer.grinded ? offer.grinded : ''
    },
    onTargetPriceUpdated ($event: TargetPriceData) {
      if ($event.label === 'sawOne') {
        this.updateSawOne($event.price, $event.totalPrice)
      }
      if ($event.label === 'sawTwo') {
        this.updateSawTwo($event.price, $event.totalPrice)
      }
      if ($event.label === 'grinded') {
        this.updateGrinded($event.price, $event.totalPrice)
      }
      this.sendOfferData()
    },
    updateSawOne (price: string, totalPrice: string) {
      this.sawOneUnitPrice = price
      this.sawOneTotalPrice = totalPrice
    },
    updateSawTwo (price: string, totalPrice: string) {
      this.sawTwoUnitPrice = price
      this.sawTwoTotalPrice = totalPrice
    },
    updateGrinded (price: string, totalPrice: string) {
      this.grindedUnitPrice = price
      this.grindedTotalPrice = totalPrice
    },
    sendOfferData (): void {
      const data: ResultasOffer = {
        species: this.species.binomen,
        internalId: this.species.internalId
      }
      if (this.hasSawOne && this.sawOneUnitPrice !== '') {
        data.sawOne = this.sawOneUnitPrice
      }
      if (this.hasSawTwo && this.sawTwoUnitPrice !== '') {
        data.sawTwo = this.sawTwoUnitPrice
      }
      if (this.hasGrinded && this.grindedUnitPrice !== '') {
        data.grinded = this.grindedUnitPrice
      }
      const total = this.calculateTotal()
      if (total !== undefined) {
        data.total = total
      }
      this.$emit('offer-updated', data)
    },
    calculateTotal (): string {
      let total = new Currency(0)
      if (this.sawOneTotalPrice !== '') {
        total = total.add(Currency.fromString(this.sawOneTotalPrice))
      }

      if (this.sawTwoTotalPrice !== '') {
        const sawTwoCurrency = Currency.fromString(this.sawTwoTotalPrice)
        total = total.add(sawTwoCurrency)
      }

      if (this.grindedTotalPrice !== '') {
        const grindedCurrency = Currency.fromString(this.grindedTotalPrice)
        total = total.add(grindedCurrency)
      }
      return (total === undefined) ? '' : total.toString()
    }
  }
})
